module.exports = __webpack_public_path__ + "img/join3-4.9a0f4c2b.svg";